export const BEGIN_API_CALL = "BEGIN_API_CALL";
export const API_CALL_ERROR = "API_CALL_ERROR";
export const LOAD_ENGINEER_SUCCESS = "LOAD_ENGINEER_SUCCESS";
export const UPDATE_ENGINEER_SUCCESS = "UPDATE_ENGINEER_SUCCESS";
export const LOAD_JOBS_SUCCESS = "LOAD_JOBS_SUCCESS";
export const CLAIM_JOB_SUCCESS = "CLAIM_JOB_SUCCESS";
export const LOAD_MY_JOBS_SUCCESS = "LOAD_MY_JOBS_SUCCESS";
export const LOAD_MY_COMPLETED_JOBS_SUCCESS = "LOAD_MY_COMPLETED_JOBS_SUCCESS";
export const COMPLETE_JOB_SUCCESS = "COMPLETE_JOB_SUCCESS";
export const RELOAD_COMPLETE_JOB_SUCCESS = "RELOAD_COMPLETE_JOB_SUCCESS";
export const LOAD_MY_INSTALLED_JOBS_SUCCESS = "LOAD_MY_INSTALLED_JOBS_SUCCESS";
export const LOAD_MY_AWAITING_PAYMENT_JOBS_SUCCESS = "LOAD_MY_AWAITING_PAYMENT_JOBS_SUCCESS";
export const LOAD_MY_PROGRESSED_JOBS_SUCCESS = "LOAD_MY_PROGRESSED_JOBS_SUCCESS";
// Background reloads that refresh signed media links. Deliberately not ending in _SUCCESS,
// so they don't affect apiCallsInProgress (no spinner).
export const REFRESH_ENGINEER = "REFRESH_ENGINEER";
export const REFRESH_COMPLETING_JOB = "REFRESH_COMPLETING_JOB";
